// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Alert, Typography } from '@metarouter-private/mr-mui';

export default function UploadResults({ results }) {
  const { succeeded, failed } = results;
  const total = succeeded + failed;
  const allSucceeded = failed === 0;
  const allFailed = succeeded === 0;

  const getSeverity = () => {
    if (allSucceeded) return 'success';
    if (allFailed) return 'error';
    return 'warning';
  };

  const getMessage = () => {
    if (allSucceeded) return `Successfully created all ${total} pipelines`;
    if (allFailed) return `Failed to create all ${total} pipelines`;
    return `Created ${succeeded} of ${total} pipelines`;
  };

  return (
    <Stack spacing={2} data-test-id="bulk-create-results">
      <Alert severity={getSeverity()}>
        <Typography variant="body1">{getMessage()}</Typography>
      </Alert>

      <Stack direction="row" spacing={4}>
        <Typography variant="body2" sx={{ color: 'success.main' }}>
          {succeeded} succeeded
        </Typography>
        <Typography variant="body2" sx={{ color: 'error.main' }}>
          {failed} failed
        </Typography>
      </Stack>

      {failed > 0 && (
        <Typography variant="body2" color="text.secondary">
          Download the report to see detailed error information.
        </Typography>
      )}
    </Stack>
  );
}

UploadResults.propTypes = {
  results: PropTypes.shape({
    succeeded: PropTypes.number.isRequired,
    failed: PropTypes.number.isRequired,
  }).isRequired,
};
